import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClientProvider } from "@tanstack/react-query";
import {  Box, Spinner, Flex } from "@chakra-ui/react";

import store, { persistor } from "./redux/store/store";
import { theme, colors } from "./theme";
import { queryClient } from "./services/queryClient";
import router from "./routes";
import Toast from "./components/Toast";
import AppLoader from "./components/AppLoader";

// Loading component for PersistGate
const LoadingScreen = () => (
  <Flex
    minH="100vh"
    bg={colors.background}
    align="center"
    justify="center"
  >
    <Spinner size="xl" color={colors.primary} />
  </Flex>
);

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<LoadingScreen />} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
         
            <Box minH="100vh" bg={colors.background}>
              <RouterProvider router={router} />
              <Toast />
              <AppLoader />
            </Box>
       
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
